import React, { useState } from 'react';

import { Box, Button, Typography, useTheme } from '@material-ui/core';
import { RiEyeLine } from 'react-icons/ri';

import { AppSwitch } from '../../../components';
import { ChangeLog } from '../../../types';
import { ProcessingPaymentChangeLogDialog } from './ProcessingPaymentChangeLogDialog';

interface Props {
  onChange: (checked: boolean) => void;
  checked: boolean;
  companyName: string;
  companyUTR: string;
  personalName: string;
  personalUTR: string;
  logs?: ChangeLog[];
}

export const ProcessingPaymentSwitch: React.FC<Props> = ({
  onChange,
  checked,
  companyName,
  companyUTR,
  personalName,
  personalUTR,
  logs,
}) => {
  const theme = useTheme();
  const [openChangeLogDialog, setOpenChangeLogDialog] = useState(false);

  return (
    <Box>
      <Typography style={{ fontSize: 18, fontWeight: 500, marginBottom: 8 }}>Processing Payments</Typography>
      <Typography variant="caption" style={{ display: 'block', marginBottom: 16 }}>
        Please choose which entity you would like to process your payments through.
      </Typography>

      <AppSwitch
        inactiveColor={theme.palette.background.default}
        checked={checked}
        onChange={onChange}
        height={56}
        leftOption={{
          content: (
            <Box display="flex" flexDirection="column" alignItems="center">
              <Typography
                style={{
                  fontSize: 13,
                  fontWeight: 500,
                  lineHeight: 1.2,
                  marginBottom: 4,
                }}
              >
                Personal Information
              </Typography>
              <Typography
                style={{
                  fontSize: 13,
                  fontWeight: 500,
                  lineHeight: 1.2,
                }}
              >
                {personalName}
              </Typography>
            </Box>
          ),
        }}
        rightOption={{
          content: (
            <Box display="flex" flexDirection="column" alignItems="center">
              <Typography
                style={{
                  fontSize: 13,
                  fontWeight: 500,
                  lineHeight: 1.2,
                  marginBottom: 4,
                }}
              >
                Limited Company Information
              </Typography>
              <Typography
                style={{
                  fontSize: 13,
                  fontWeight: 500,
                  lineHeight: 1.2,
                }}
              >
                {companyName}
              </Typography>
            </Box>
          ),
        }}
      />

      <Box display="flex" justifyContent="space-between" alignItems="center" marginTop={2}>
        <Typography variant="caption" style={{ display: 'block' }}>
          Your payments will be processed as {checked ? companyName : personalName}{' '}
          {checked ? `(UTR: ${companyUTR})` : `(UTR: ${personalUTR})`}
        </Typography>

        <Button
          variant="outlined"
          color="primary"
          startIcon={<RiEyeLine size="21px" />}
          onClick={() => setOpenChangeLogDialog(true)}
        >
          Changes
        </Button>
      </Box>

      <ProcessingPaymentChangeLogDialog
        open={openChangeLogDialog}
        handleClose={() => setOpenChangeLogDialog(false)}
        logs={logs || []}
      />
    </Box>
  );
};
